import React, { useState } from 'react';
import { CheckIcon, FilePdfIcon, ArrowDownIcon, CaretDownIcon } from '@phosphor-icons/react';
import NotifyMeButton from './NotifyMeButton';

const ExploreCard = ({ pack, onSetReminder, isMobile = false }) => {
  const [imageError, setImageError] = useState(false);
  const [showDescriptionPoints, setShowDescriptionPoints] = useState(false);

  const handleSetReminder = async () => {
    await onSetReminder(pack._id, pack.title);
  };

  const handleJoinTestSeries = () => {
    if (pack.paymentLink) {
      const user = JSON.parse(localStorage.getItem('userProfile'));
      const url =
        pack.paymentLink +
        `&utm_source=quizrr_dashboard&utm_medium=pack_upselling&utm_campaign=pack_upselling&name=${user?.name}&email=${user?.email}&confirmEmail=${user?.email}&phone=${user?.mobileNumber?.split('+91')[1]}`;
      window.open(url, '_blank');
    }
  };

  const handleViewDetails = () => {
    if (pack.detailsUrl) {
      const url =
        pack.detailsUrl + '?utm_source=quizrr_dashboard&utm_medium=pack_upselling&utm_campaign=pack_upselling';
      window.open(url, '_blank');
    }
  };

  const defaultThumbnail = '/placeholder-test-series.jpg';

  //MOBILE LAYOUT
  if (isMobile) {
    return (
      <div className="relative rounded-xl border-[2px] border-[var(--q3-stroke-light)] bg-[var(--q3-surface-default)] overflow-hidden max-w-[90%] mx-auto">
        <div className="w-full h-[120px] overflow-hidden">
          <img
            src={pack.thumbnail || defaultThumbnail}
            alt={pack.title}
            className="w-full h-full object-cover"
            onError={(e) => {
              setImageError(true);
              e.target.src = defaultThumbnail;
            }}
          />
        </div>
        {!pack.paymentLink && (
          <div className="absolute bg-[var(--q3-danger-normal)] text-[var(--q3-neutral-default_inverted)] top-0 right-5 px-2 py-1 rounded-b-lg text-xs">
            Coming Soon
          </div>
        )}
        <div className="p-4">
          <div className="flex items-start space-x-3 mb-3">
            <img
              src={pack.icon}
              alt={pack.title}
              className="w-10 h-10 rounded-lg flex-shrink-0"
              onError={(e) => {
                e.target.src = defaultThumbnail;
              }}
            />

            <h3 className="font-semibold text-[var(--q3-neutral-default)] text-base leading-tight flex-1">
              {pack.title}
            </h3>
          </div>

          {pack.schedulePdf && (
            <div
              className="flex items-center space-x-2 text-xs text-[var(--q3-neutral-light)] mb-3 cursor-pointer"
              onClick={() => {
                window.open(pack.schedulePdf, '_blank');
              }}
            >
              <FilePdfIcon size={14} />
              <span>Download schedule</span>
            </div>
          )}

          <div className="mb-4">
            <button
              onClick={() => setShowDescriptionPoints(!showDescriptionPoints)}
              className="flex items-center space-x-2 text-sm text-[var(--q3-neutral-default)] cursor-pointer"
            >
              <span>What you'll get in this test series?</span>
              <CaretDownIcon
                size={16}
                className={`transform transition-transform ${showDescriptionPoints ? 'rotate-180' : ''}`}
              />
            </button>

            {showDescriptionPoints && (
              <div className="mt-3 space-y-2 pl-2">
                {pack.descriptionPoints.map((point, index) => (
                  <div key={index} className="flex items-start space-x-2">
                    <CheckIcon size={14} className="text-[var(--q3-neutral-light)] mt-1 flex-shrink-0" />
                    <span className="text-xs text-[var(--q3-neutral-light)]">{point}</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="space-y-2">
            {pack.paymentLink ? (
              <>
                {pack.detailsUrl && (
                  <button
                    onClick={handleViewDetails}
                    className="
                    w-full flex items-center justify-center space-x-1 
                    h-[40px] p-2 
                    rounded-full border border-[var(--q3-stroke-normal)] 
                    bg-[var(--q3-surface-default)]
                    text-xs text-[var(--q3-neutral-default)]
                    transition-colors cursor-pointer
                  "
                  >
                    <span>View More Details</span>
                  </button>
                )}

                <button
                  onClick={handleJoinTestSeries}
                  className="
                    w-full flex items-center justify-center h-[40px] p-2
                    rounded-full bg-[var(--q3-danger-normal)]
                    text-[var(--q3-neutral-default_inverted)]  text-xs hover:bg-opacity-90 
                    transition-colors cursor-pointer
                  "
                >
                  Join Test Series
                </button>
              </>
            ) : (
              <div className="w-full">
                <NotifyMeButton
                  onSetReminder={handleSetReminder}
                  isReminderSet={pack.isReminderSet || false}
                  className="w-full"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  //DESKTOP LAYOUT
  return (
    <div
      className="
        relative flex-shrink-0 w-[360px] rounded-xl border-[2px] 
        border-[var(--q3-stroke-light)] bg-[var(--q3-surface-default)] 
        overflow-hidden flex flex-col h-[430px]
      "
    >
      {/* IMAGE */}
      <div className="w-full h-[130px] overflow-hidden">
        <img
          src={pack.thumbnail || defaultThumbnail}
          alt={pack.title}
          className="w-full h-full object-cover"
          onError={(e) => {
            setImageError(true);
            e.target.src = defaultThumbnail;
          }}
        />
      </div>

      {!pack.paymentLink && (
        <div className="absolute bg-[var(--q3-danger-normal)] text-[var(--q3-neutral-default_inverted)] top-0 right-5 px-2 py-1 rounded-b-lg text-sm">
          Coming Soon
        </div>
      )}

      {/* CONTENT */}
      <div className="p-4 flex-1 flex flex-col overflow-hidden">
        <div className="flex items-start space-x-3 mb-3">
          <img
            src={pack.icon}
            alt={pack.title}
            className="w-10 h-10 rounded-lg flex-shrink-0"
            onError={(e) => {
              e.target.src = defaultThumbnail;
            }}
          />

          <h3 className="font-semibold text-[var(--q3-neutral-default)] text-lg leading-tight line-clamp-2">
            {pack.title}
          </h3>
        </div>

        {pack.schedulePdf && (
          <div
            className="flex items-center space-x-2 text-sm text-[var(--q3-neutral-light)] mb-4 cursor-pointer"
            onClick={() => {
              window.open(pack.schedulePdf, '_blank');
            }}
          >
            <FilePdfIcon size={16} />
            <span>Download schedule</span>
          </div>
        )}

        <div className="space-y-2 mb-4 overflow-auto pr-1 custom-scroll">
          {pack.descriptionPoints.map((point, index) => (
            <div key={index} className="flex items-start space-x-2">
              <CheckIcon size={16} className="text-[var(--q3-neutral-light)] mt-1 flex-shrink-0" />
              <span className="text-sm text-[var(--q3-neutral-light)]">{point}</span>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between gap-3 mt-auto">
          {pack.paymentLink ? (
            <>
              {/* View More Details */}
              {pack.detailsUrl && (
                <button
                  onClick={handleViewDetails}
                  className="
                  flex items-center justify-center space-x-1
                  h-[40px] p-2 flex-1
                  rounded-full border border-[var(--q3-stroke-normal)]
                  bg-[var(--q3-surface-default)]
                  text-sm text-[var(--q3-neutral-default)]
                  transition-colors cursor-pointer
                "
                >
                  <span>View More Details</span>
                </button>
              )}

              {/* Join Test Series */}
              <button
                onClick={handleJoinTestSeries}
                className="
                  flex items-center justify-center
                  h-[40px] p-2 flex-1
                  rounded-full bg-[var(--q3-danger-normal)]
                  text-[var(--q3-neutral-default_inverted)] text-sm
                  transition-colors cursor-pointer
                "
              >
                Join Test Series
              </button>
            </>
          ) : (
            <NotifyMeButton onSetReminder={handleSetReminder} isReminderSet={pack.isReminderSet || false} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ExploreCard;
